import React from 'react'
import { Flex, FlexProps } from 'rebass/styled-components'

export interface BreadcrumbItemProps extends FlexProps {
  isLastItem: boolean
}

export const BreadcrumbItem = ({ children, isLastItem, sx, ...props }: BreadcrumbItemProps): JSX.Element => (
  <Flex data-name="BreadcrumbItem" as="li" sx={{ alignItems: 'center', gap: '8px', ...sx }} {...props}>
    {children}
    {!isLastItem && (
      // 👇 '/' divider line
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="22"
        fill="none"
        viewBox="0 0 9 22"
        role="presentation"
        aria-hidden="true"
      >
        <path fill="#C4C4C4" d="m7.182.962.94.342L.939 21.037 0 20.695z" />
      </svg>
    )}
  </Flex>
)
